import { useRef, useState } from 'react';
import { Pagination, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ShowroomGallery/ShowroomGallery.styles';
import { IPointOfPresenceGalleryItem } from '@features/checkout/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  gallery: Array<IPointOfPresenceGalleryItem>;
};
const ShowroomGallery = ({
  gallery
}: PropsType) => {
  const swiperInstance = useRef<SwiperClass>(null);
  const [firstImageLoaded, setFirstImageLoaded] = useState<boolean>(false);
  const pagination = {
    clickable: true,
    renderBullet: (i: number, className: string) => `<span class="${className}" data-index="${i}"></span>`
  };
  const onLoadFirstImage = () => {
    setFirstImageLoaded(true);
  };
  return <div sx={styles.container}>
      <Swiper modules={[Pagination, Mousewheel]} pagination={pagination} onSwiper={swiper => {
      swiperInstance.current = swiper;
    }} spaceBetween={0} mousewheel>
        {gallery.slice(0, 1).map(item => <SwiperSlide key={`${item.sizes.ORGINAL}-${Math.random()}`}>
            <ResponsiveImage image={item.sizes.ORGINAL} alt="" onLoad={onLoadFirstImage} />
          </SwiperSlide>)}
        {firstImageLoaded && gallery.slice(1, 9).map(item => <SwiperSlide key={`${item.sizes.ORGINAL}-${Math.random()}`}>
              <ResponsiveImage image={item.sizes.ORGINAL} alt="" />
            </SwiperSlide>)}
      </Swiper>
    </div>;
};
export default ShowroomGallery;